import { Action, any, async, fromJSX, nothing } from "widgets-for-react";
import { MoodGroupListWithCover } from "../../../../custom_api/bookarang/types";
import { pushMoodBasedInspirationAction } from "../../datalayer";
import { CollectionPageLoaderWidget } from "../Shared/InspirationUtils";
import { MoodBasedInspirationLayoutKiosk } from "./MoodBasedInspirationLayoutKiosk";
import { MoodBasedInspirationLayoutWeb } from "./MoodBasedInspirationLayoutWeb";
import { MoodBasedInspirationLayoutProps, MoodBasedInspirationState } from "./MoodBasedInspirationState";

export const MoodBasedInspirationWidget = (props: MoodBasedInspirationState) => {
  return any<Action<MoodBasedInspirationState>>({ key: `Mood-based` })([
    fromJSX((setState) => {
      const layoutProps: MoodBasedInspirationLayoutProps = {
        ...props,
        pushDataLayer: (action: string, label: string) => {
          pushMoodBasedInspirationAction(action, label)
        }
      }
      return props.isKioskMode
        ? MoodBasedInspirationLayoutKiosk(layoutProps)
        : MoodBasedInspirationLayoutWeb(layoutProps)
    }),
    async<MoodGroupListWithCover[]>(nothing, { key: 'MoodBasedPromptsLoader' })(props.moodGroups)
      .map(resultUpdater => (s0): MoodBasedInspirationState => {
        let moodGroups = resultUpdater(s0.moodGroups)
        return ({ ...s0, moodGroups })
      }),
    CollectionPageLoaderWidget(props)
  ]).map(a => a(props))
}
